import { getThrowCapability } from './throwCapability'

export const MIN_TOWER_LEVEL = 0 as const
export const MAX_TOWER_LEVEL = 4 as const

export type TowerLevel = 0 | 1 | 2 | 3 | 4
export type TowerLane = 'bear' | 'spa'

export interface TowerV2State {
  bearLevel: TowerLevel
  spaLevel: TowerLevel
}

export interface ResolvedHoneyVisual {
  compositeKey: 'tower-v2-honey-l0'
  fishSheetKey: 'tower-v2-honey-fish-swim'
  renderedBearLevel: TowerLevel
  renderedSpaLevel: TowerLevel
  usesFallbackArt: boolean
  canThrow: boolean
}

export function createTowerState(): TowerV2State {
  return { bearLevel: 0, spaLevel: 0 }
}

export function clampTowerLevel(level: number): TowerLevel {
  if (!Number.isFinite(level)) return MIN_TOWER_LEVEL
  return Math.min(MAX_TOWER_LEVEL, Math.max(MIN_TOWER_LEVEL, Math.floor(level))) as TowerLevel
}

export function setTowerLevel(state: TowerV2State, lane: TowerLane, level: number): TowerV2State {
  const next = clampTowerLevel(level)
  return lane === 'bear'
    ? { ...state, bearLevel: next }
    : { ...state, spaLevel: next }
}

export function changeTowerLevel(state: TowerV2State, lane: TowerLane, delta: number): TowerV2State {
  const current = lane === 'bear' ? state.bearLevel : state.spaLevel
  return setTowerLevel(state, lane, current + delta)
}

export function resolveHoneyVisual(state: TowerV2State): ResolvedHoneyVisual {
  const usesFallbackArt = state.bearLevel !== 0 || state.spaLevel !== 0
  return {
    compositeKey: 'tower-v2-honey-l0',
    fishSheetKey: 'tower-v2-honey-fish-swim',
    renderedBearLevel: 0,
    renderedSpaLevel: 0,
    usesFallbackArt,
    // Attack ability comes only from an explicitly registered throw clip,
    // never from a static sprite or selected upgrade levels.
    canThrow: getThrowCapability('honey') !== null,
  }
}
